import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Button, TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { useDispatch, useSelector } from "react-redux";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import { disposeAsset } from "../../actions/disposal";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";
import API from "../../Api/api";
import { Helmet } from "react-helmet-async";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "white",
  color: "black",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const columns = [
  { id: "code", label: "Code", minWidth: 100 },
  {
    id: "asset_pool",
    label: "Asset Pool ",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "location",
    label: "Location ",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "sub_location",
    label: "Sub-Location",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "serial_chassis",
    label: "Serial/Chassis Number",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "cost",
    label: "Cost",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "accum_depre",
    label: "Accum. Depre.",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "carrying_amount",
    label: "Carrying Amt",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "disposal_value",
    label: "Disposal Value",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "profit_loss",
    label: "Profit/Loss",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "disposal_date",
    label: "Disposal Date",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "disposal_reason",
    label: "Disposal Reason",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "disposal_method",
    label: "Disposal Method",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
];

function createData(
  code,
  asset_pool,
  location,
  sub_location,
  serial_chassis,
  cost,
  accum_depre,
  disposal_value,
  disposal_date,
  disposal_reason,
  disposal_method
) {
  const carrying_amount = cost - accum_depre;
  const profit_loss = disposal_value - carrying_amount;
  return {
    code,
    asset_pool,
    location,
    sub_location,
    serial_chassis,
    cost,
    accum_depre,
    carrying_amount,
    disposal_value,
    profit_loss,
    disposal_date,
    disposal_reason,
    disposal_method,
  };
}

export default function AssetDisposal() {
  const mode_state = useSelector((state) => state.mode);
  const [mode, setMode] = React.useState(mode_state);
  React.useEffect(() => {
    setMode(mode_state);
  }, [mode_state]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [open, setOpen] = React.useState(false);

  const user = JSON.parse(secureLocalStorage.getItem("profile"));
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const [fromDb, setFromDb] = React.useState([]);
  const [disposedData, setDisposedData] = React.useState({
    disposal_date: "",
    disposal_method: "",
    disposal_reason: "",
    code: "",
    cost: "",
  });
  React.useEffect(() => {
    const fetchData = async () => {
      const res = await API.get(
        `/api/v1/company-assets/ppe/ppe-section?code=${disposedData.code}`
      );
      if (res.data) {
        setFromDb(res.data);
      } else {
        setFromDb([]);
      }
    };
    fetchData();
  }, [disposedData.code]);
  const today = moment(disposedData.disposal_date);
  const purchase_date = fromDb[0]?.purchase_date;
  const exhaustion_date = fromDb[0]?.exhaustion_date;
  const cost = fromDb[0]?.cost;
  // const asset_life = fromDb?.asset_life;
  const daily_depreciation = fromDb[0]?.daily_depreciation;
  const diff = today.diff(purchase_date, "days");

  const accumulated_depreciation =
    moment(exhaustion_date) <= moment(disposedData.disposal_date)
      ? cost
      : daily_depreciation * (diff - 1);

  const postData = {
    disposal_date: disposedData.disposal_date,
    disposal_method: disposedData.disposal_method,
    disposal_reason: disposedData.disposal_reason,
    disposal_value: disposedData.cost,
    disposed: "true",
    disposed_by: user.results.firstName + " " + user.results.lastName,
    accumulated_depreciation: accumulated_depreciation,
  };
  const dispatch = useDispatch();
  function disposeAssets() {
    if (fromDb[0]?._id) {
      dispatch(disposeAsset(postData, fromDb[0]._id));
      alert("assets disposed");
      setDisposedData({
        disposal_date: "",
        disposal_method: "",
        disposal_reason: "",
        code: "",
        cost: "",
      });
      handleClose();
    } else {
      return;
    }
  }
  const assetsData = useSelector((state) => state.assets);
  const disposals = useSelector((state) => state.disposed);
  let options = [];
  assetsData?.map((data) => options.push(data.code));
  const rows = disposals?.map((data) => {
    return createData(
      data.code,
      data.category,
      data.location,
      data.sub_location,
      data.serial_number,
      data.cost,
      data.accumulated_depreciation,
      data.disposal_value,
      moment(data.disposal_date).format("YYYY-MM-DD"),
      data.disposal_reason,
      data.disposal_method
    );
  });
  let allowManipulate = false;
  if (
    user.results.assets === "Administrator" ||
    user.results.assets === "Read-Write"
  ) {
    allowManipulate = true;
  } else {
    allowManipulate = false;
  }
  return (
    <div style={{ height: "calc(80dvh - 100px)" }}>
      <Helmet>
        <title>Asset Disposal</title>
      </Helmet>
      <Paper
        sx={{
          width: "100%",
          backgroundColor: `${mode === "dark" ? "#303030" : "#ffffff"}`,
          height: "calc(77dvh - 100px)",
        }}>
        <Modal
          aria-labelledby='transition-modal-title'
          aria-describedby='transition-modal-description'
          open={open}
          onClose={handleClose}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}>
          <Fade in={open}>
            <Box sx={style}>
              <Typography
                id='transition-modal-title'
                variant='h5'
                component='h2'
                style={{ marginBottom: "15px" }}>
                Dispose Asset
              </Typography>
              <form style={{ display: "flex", flexDirection: "column" }}>
                <Autocomplete
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  disablePortal
                  id='combo-box-demo'
                  options={options}
                  onChange={(e, n) =>
                    setDisposedData({ ...disposedData, code: n })
                  }
                  sx={{ width: 300 }}
                  renderInput={(params) => (
                    <TextField {...params} label='Asset' />
                  )}
                />
                <label htmlFor='revaluation-date'>Disposal Date</label>
                <TextField
                  id='revaluation-date'
                  style={{ marginBottom: "10px" }}
                  type='date'
                  value={disposedData.disposal_date}
                  onChange={(e) =>
                    setDisposedData({
                      ...disposedData,
                      disposal_date: e.target.value,
                    })
                  }
                  size='small'
                  required
                />
                <TextField
                  style={{ marginBottom: "10px" }}
                  type='text'
                  size='small'
                  label='Disposal Method'
                  value={disposedData.disposal_method}
                  onChange={(e) =>
                    setDisposedData({
                      ...disposedData,
                      disposal_method: e.target.value,
                    })
                  }
                  required
                />
                <TextField
                  style={{ marginBottom: "10px" }}
                  type='number'
                  size='small'
                  label='Disposal value'
                  value={disposedData.cost}
                  onChange={(e) =>
                    setDisposedData({ ...disposedData, cost: e.target.value })
                  }
                  required
                />
                <TextField
                  style={{ marginBottom: "10px" }}
                  type='text'
                  size='small'
                  label='Disposal reason'
                  value={disposedData.disposal_reason}
                  onChange={(e) =>
                    setDisposedData({
                      ...disposedData,
                      disposal_reason: e.target.value,
                    })
                  }
                  required
                />

                <div>
                  <Button
                    onClick={disposeAssets}
                    variant='contained'
                    size='small'
                    style={{
                      textTransform: "none",
                      margin: "5px",
                      backgroundColor: `${
                        mode === "dark" ? "#0883FF" : "#116149"
                      }`,
                    }}>
                    Submit
                  </Button>
                  <Button
                    variant='contained'
                    style={{
                      textTransform: "none",
                      backgroundColor: "#D32F2F",
                    }}
                    onClick={handleClose}
                    size='small'>
                    Cancel
                  </Button>
                </div>
              </form>
            </Box>
          </Fade>
        </Modal>
        <Button
          disabled={!allowManipulate}
          style={{
            textTransform: "capitalize",
            margin: "5px",
            backgroundColor: `${mode === "dark" ? "#0883FF" : "#116149"}`,
          }}
          onClick={handleOpen}
          variant='contained'>
          Dispose Asset
        </Button>
        <em style={{ color: "red" }}>
          {allowManipulate
            ? ""
            : "you don't have the permission to dispose asset"}
        </em>
        <TableContainer
          style={{
            backgroundColor: `${mode === "dark" ? "#303030" : "#E9F1F7"}`,
            color: `${mode === "dark" ? "rgba(255,255,255,0.65)" : "#000"}`,
            height: "calc(80dvh - 100px)",
          }}>
          <Table
            size='small'
            stickyHeader
            aria-label='sticky table'
            style={{ backgroundColor: "#E9F1F7" }}
            sx={
              {
                // "& tr > *:last-child": {
                //   position: "sticky",
                //   right: 0,
                //   // bgcolor: "#cccc",
                // },
              }
            }>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      top: 0,
                      minWidth: column.minWidth,
                      backgroundColor: "#3D4F58",
                      color: `${
                        mode === "dark" ? "rgba(255,255,255,0.65)" : "#ccc"
                      }`,
                    }}>
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  return (
                    <TableRow
                      hover
                      role='checkbox'
                      tabIndex={-1}
                      key={row.code}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell
                            style={{
                              backgroundColor: `${
                                mode === "dark" ? "#303030" : "#E9F1F7"
                              }`,
                              color: `${
                                mode === "dark"
                                  ? "rgba(255,255,255,0.65)"
                                  : "#000"
                              }`,
                            }}
                            key={column.id}
                            align={column.align}>
                            {column.format && typeof value === "number"
                              ? column.format(value)
                              : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          style={{
            backgroundColor: `${mode === "dark" ? "#303030" : "#E9F1F7"}`,
            color: `${mode === "dark" ? "rgba(255,255,255,0.65)" : "#000"}`,
          }}
          rowsPerPageOptions={[10, 25, 100]}
          component='div'
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
